import React, { useRef, useEffect, useState} from 'react'
import { Select, MenuItem } from '@mui/material';
import { gsap } from 'gsap'
import { ConfigInfo } from '../../Alarm Functions/AlarmOverviewFunctions'
import NumberField from '../../../components/CustomInput/NumberField';
import { flowRateUnits, flowUnits, pressureUnits } from '../../../Utils/UnitConverters'
import { TimePicker } from '@mui/x-date-pickers';
import {inputUnits } from '../../../Utils/CurrentInputUnits'
import AlarmInfoIconAndTitle from '../AlarmInfoIcon'
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
interface Props {
    condition: string | null | undefined
    value: number | null | undefined
    unit: string | null | undefined
    clearCondition: string | null | undefined
    clearValue: number | null | undefined
    consumptionTimeframe: number | null | undefined
    consumptionTimeframeUnit: string | null | undefined
    handleAlarmChanges: (name: string, value: string | number) => void
    configInfo: ConfigInfo
    type: string | undefined
    channel: string | undefined | null
}


interface Units {
    name: string
    value: string
}

const Page2: React.FC<Props> = ({
    condition,
    value,
    unit,
    clearCondition,
    clearValue,
    consumptionTimeframe,
    consumptionTimeframeUnit,
    handleAlarmChanges,
    configInfo,
    type,
    channel
}) => {

    const intl:IntlShape = useIntl()


    //state
    const [unitType, setUnitType] = useState<Units[]>([])


    ///useRef
    const setTitleRef = useRef<HTMLHeadingElement>(null)
    const setConditionRef = useRef<HTMLDivElement>(null)
    const setValueRef = useRef<HTMLDivElement>(null)
    const setUnitRef = useRef<HTMLDivElement>(null)
    const clearTitleRef = useRef<HTMLHeadingElement>(null)
    const clearConditionRef = useRef<HTMLDivElement>(null)
    const clearValueRef = useRef<HTMLDivElement>(null)
    const clearUnitRef = useRef<HTMLDivElement>(null)


    const selectStyle = {
        width: '50%',
        margin: '20px',
        opacity: 0
    }

    const conditionMenuItems = [
        <MenuItem key={0} value='='><FormattedMessage id="is Equal to (=)" /></MenuItem>,
        <MenuItem key={1} value='!='><FormattedMessage id="is not Equal to (!=)" /></MenuItem>,
        <MenuItem key={2} value='<'><FormattedMessage id="is Less than" /> (&lt;)</MenuItem>,
        <MenuItem key={3} value='>'><FormattedMessage id="is Greater than" /> (&gt;)</MenuItem>,
        <MenuItem key={4} value='<='><FormattedMessage id="is Less than or Equal to" /> (&#x2264;)</MenuItem>,
        <MenuItem key={5} value='>='><FormattedMessage id="is Greater than or Equal to" /> (&#x2265;)</MenuItem>
    ]

    useEffect(() => {
        const setTitle = setTitleRef?.current
        const setCondition = setConditionRef?.current
        const setValue = setValueRef?.current
        const setUnit = setUnitRef?.current
        const clearTitle = clearTitleRef?.current
        const clearCondition = clearConditionRef?.current
        const clearValue = clearValueRef?.current
        const clearUnit = clearUnitRef?.current

        const entryGsap = {
            opacity: 1,
            duration: 0.4,
            ease: 'power2.out'
        }
        const gap = '-=0.3'

        const tl = gsap.timeline()

        tl.to(setTitle, entryGsap)
        tl.to(setCondition, entryGsap, gap)
        tl.to(setValue, entryGsap, gap)
        tl.to(setUnit, entryGsap, gap)
        tl.to(clearTitle, entryGsap, gap)
        tl.to(clearCondition, entryGsap, gap)
        tl.to(clearValue, entryGsap, gap)
        tl.to(clearUnit, entryGsap, gap)


    }, [])

    const batteryTypes = [
        //{ name: '% remaining', value: '%' },
        { name: 'voltage (V)', value: 'V' },
        //{ name: 'years remaining', value: 'years'}
    ]
    useEffect(() => {
        if (type === 'consumption') {
            setUnitType(flowUnits)
        }
        if (type === 'flow' || type === 'mnf') {
            setUnitType(flowRateUnits)
        }
        if (type === 'pressure' || type === 'pressureDiff') {
            setUnitType(pressureUnits)
        } 
        if (type === 'analog') {
            if (channel === 'C') {
                handleAlarmChanges('unit', inputUnits[configInfo.chanCUnit].value)
            }
            if (channel === 'D') {
                handleAlarmChanges('unit', inputUnits[configInfo.chanDUnit].value)
            }
        }
        if (type === 'battery') {
            setUnitType(batteryTypes)
        }
        if (type === 'signal') {
            setUnitType([{name: 'RSSI', value: 'rssi'}])
        }
        if (type === 'temperature') {
            setUnitType([
                { name: 'Centigrade (C)', value: 'c' },
                { name: 'Fahrenheit (F)', value: 'f'}
            ])
        }
        
    }, [type])

    return (
        <div style={{ padding: 30 }}>
            <h4 ref={setTitleRef}><b><FormattedMessage id="Set Alarm Condition" /></b></h4>
            <div style={{ display: 'flex', width: '100%' }}>
                {type !== 'digital' ? <div style={selectStyle} ref={setConditionRef}>
                    <AlarmInfoIconAndTitle title={intl.formatMessage({ id: "Alarm Condition" })} text={intl.formatMessage({ id: "Sets the condition / operator for when the alarm will be triggered" })} />
                    <Select
                        value={condition}
                        fullWidth
                        style={{ zIndex: 1000000 }}
                        name='condition'
                        onChange={(e): void => {
                            if (e.target.value) {
                                handleAlarmChanges(e.target.name, e.target.value)
                            }
                        }}
                    >
                        {conditionMenuItems.map(itm => {
                            return itm
                        })}
                    </Select>
                </div> :
                <div style={selectStyle} ref={setConditionRef}>
                    <p><b><FormattedMessage id="Alarm Condition" /></b></p>
                    <div style={{ border: '1px solid #cccccc', borderRadius: '4px', height: '57px' }}>
                        <p style={{ margin: '15px 0 0 13px', fontWeight: 500 }}><FormattedMessage id="is Equal to (=)" /></p>
                    </div>
                </div>}
                {type !== 'digital' ? <div style={selectStyle} ref={setValueRef}>
                    <AlarmInfoIconAndTitle title={intl.formatMessage({ id: "Alarm Value" })} text={intl.formatMessage({ id: "Set the threshold / value for when this alarm will be triggered" })} />
                    <NumberField
                        value={value}
                        disabled={!condition}
                        onValueChange={(e: number): void => handleAlarmChanges('value', e)}
                        size='medium'
                        width='100%'
                        fullWidth
                    />
                </div> :
                <div style={selectStyle} ref={setValueRef}>
                        <AlarmInfoIconAndTitle title={intl.formatMessage({ id: "Alarm Value" })} text={intl.formatMessage({ id: "Sets the trigger value for the digital alarm, this is either ON / OF depending on how its been set up" })} />
                        <Select
                            value={value }
                            name='value'
                            onChange={(e): void => {
                                handleAlarmChanges(e.target.name, e.target.value)
                            }}
                            size='medium'
                            width='100%'
                            fullWidth
                        >
                            <MenuItem value="1"><FormattedMessage id="ON (1)" /></MenuItem>
                            <MenuItem value="0"><FormattedMessage id="OFF (0)" /></MenuItem>
                        </Select>
                </div>}
                {type !== 'digital' && <div style={selectStyle} ref={setUnitRef}>
                    <AlarmInfoIconAndTitle title={intl.formatMessage({ id: "Unit" })} text={intl.formatMessage({ id: "Sets the unit for the alarm trigger (e.g. if Flow  then l/s)" })} />
                    {type !== 'analog' ?
                        <Select
                            value={unit}
                            fullWidth
                            disabled={!condition}
                            name='unit'
                            onChange={(e): void => {
                                if (e.target.value) {
                                    handleAlarmChanges(e.target.name, e.target.value)
                                }
                            }}
                        >
                            {unitType && unitType.length > 0 && unitType.map((u, idx) => {
                                return (
                                    <MenuItem key={idx} value={u.value}>{u.name}</MenuItem>
                                )
                            })}
                        </Select>
                        :
                        <div style={{ border: '1px solid #cccccc', borderRadius: '4px', height: '57px' }}>
                            <p style={{ margin: '15px 0 0 13px', fontWeight: 500 }}>{unit}</p>
                        </div>}
                </div>}
            </div>
            {type !== 'consumption' ?
                <div>
                    <h4 ref={clearTitleRef}><b><FormattedMessage id="Set Clear Condition" /></b></h4>
                    <div style={{ display: 'flex', width: '100%' }}>
                        {console.log(value) }
                        {type !== 'digital' ? <div style={selectStyle} ref={clearConditionRef}>
                            <AlarmInfoIconAndTitle title={intl.formatMessage({ id: "Alarm Clear Condition" })} text={intl.formatMessage({ id: "Sets the condition / operator for when the alarm will be cleared" })} />
                            <Select
                                value={clearCondition}
                                fullWidth
                                disabled={!condition || !value?.toString() || !unit}
                                style={{ zIndex: 1000000 }}
                                name='clearCondition'
                                onChange={(e): void => handleAlarmChanges(e.target.name, e.target.value)}
                            >
                                {conditionMenuItems.map(itm => {
                                    if ((condition === '>' || condition === '>=') && itm.props.value !== '>' && itm.props.value !== '>=') {
                                        return itm
                                    } else if ((condition === '<' || condition === '<=') && itm.props.value !== '<' && itm.props.value !== '<=') {
                                        return itm
                                    } else if (condition !== '>' && condition !== '>=' && condition !== '<' && condition !== '<=') {
                                        return itm
                                    }
                                    return

                                })}
                            </Select> 
                        </div> :
                            <div style={selectStyle} ref={clearConditionRef}>
                                <p><b><FormattedMessage id="Alarm Condition" /></b></p>
                                <div style={{ border: '1px solid #cccccc', borderRadius: '4px', height: '57px' }}>
                                    <p style={{ margin: '15px 0 0 13px', fontWeight: 500 }}><FormattedMessage id="is Equal to (=)" /></p>
                                </div>
                            </div>
                        }
                        {type !== 'digital' ? <div style={selectStyle} ref={clearValueRef}>
                            <AlarmInfoIconAndTitle title={intl.formatMessage({ id: "Alarm Clear Value" })} text={intl.formatMessage({ id: "Set the threshold / value for when this alarm will be cleared" })} />
                            <NumberField
                                value={clearValue}
                                disabled={!condition || !value.toString() || !unit || !clearCondition}
                                onValueChange={(e: number): void => handleAlarmChanges('clearValue', e)}
                                size='medium'
                                width='100%'
                                fullWidth
                            />
                        </div> :
                        <div style={selectStyle} ref={clearValueRef}>
                                <AlarmInfoIconAndTitle title={intl.formatMessage({ id: "Alarm Clear Value" })} text={intl.formatMessage({ id: "Sets the clear value for the digital alarm, this is either ON / OFF depending on how its been set up" })} />
                            <Select
                                value={clearValue}
                                name='clearValue'
                                onChange={(e): void => {
                                    if (e.target.value) {
                                        handleAlarmChanges(e.target.name, e.target.value)
                                    }
                                }}
                                size='medium'
                                width='100%'
                                fullWidth
                            >
                                <MenuItem value={1}><FormattedMessage id="ON (1)" /></MenuItem>
                                <MenuItem value={0}><FormattedMessage id="OFF (0)" /></MenuItem>
                            </Select>
                        </div>}
                        {type !== 'digital' && <div style={selectStyle} ref={clearUnitRef}>
                            <p><b><FormattedMessage id="Unit" /></b></p>
                            <div style={{ border: '1px solid #cccccc', borderRadius: '4px', height: '57px' }}>
                                {type !== 'analog' ?
                                    <p style={{ margin: '15px 0 0 13px', fontWeight: 400, fontSize: '16px', color: '#2a2a2a' }}>{unitType.find(u => u.value === unit)?.name}</p> :
                                    <p style={{ margin: '15px 0 0 13px', fontWeight: 500 }}>{unit}</p>
                                }
                            </div>
                        </div>}
                    </div>
                </div>
                :
                <div>
                    <h4 ref={clearTitleRef}><b><FormattedMessage id="Within the last" /></b></h4>
                    <div style={{ display: 'flex', width: '66.66666%' }}>
                        <div style={selectStyle} ref={clearConditionRef}>
                            <AlarmInfoIconAndTitle title={intl.formatMessage({ id: "Consumption Timeframe Value" })} text={intl.formatMessage({ id: "Set the value for how big the window will be to test the consumption (e.g. if 1 day, set to 1)" })} />
                            <NumberField
                                value={consumptionTimeframe}
                                disabled={!condition || !value?.toString() || !unit}
                                onValueChange={(e: number): void => handleAlarmChanges('consumptionTimeframe', e)}
                                fullWidth
                                width='100%'
                                min={1}
                                
                            />
                        </div>
                        <div style={selectStyle} ref={clearValueRef}>
                            <AlarmInfoIconAndTitle title={intl.formatMessage({ id: "Consumption Timeframe Unit" })} text={intl.formatMessage({ id: "Set the unit for the alarm window (e.g. if 1 day, set to days)" })} />
                            <Select
                                value={consumptionTimeframeUnit}
                                disabled={!consumptionTimeframe?.toString()}
                                fullWidth
                                name='consumptionTimeframeUnit'
                                onChange={(e): void => {
                                    if (e.target.value) {
                                        handleAlarmChanges(e.target.name, e.target.value)
                                    }
                                }}
                            >
                                <MenuItem value='hours'><FormattedMessage id="Hours" /></MenuItem>
                                <MenuItem value='days'><FormattedMessage id="Days" /></MenuItem>
                                <MenuItem value='weeks'><FormattedMessage id="Weeks" /></MenuItem>
                                <MenuItem value='months'><FormattedMessage id="Months" /></MenuItem>
                            </Select>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}
export default Page2